const SocialState = Object.freeze({
  INDEPENDANT: 'independant',
  EMPLOYE: 'employe',
  OUVRIER: 'ouvrier',
  ASSISTANT: 'assistant',
  SANS_EMPLOI: 'sans_emploi',
  INCONNU: 'inconnu',
  AUTRE: 'autre',
})

export default SocialState
